module.exports = __webpack_public_path__ + "img/img_works12.32373e64.jpg";